import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import TotalPayementList from "./totalpaymentlist";
import TotalSaleList from "./totalsalelist";
import LocalAccess from "./localaccess";
import PaymentReconcile from "./paymentreconcile";
import { getFetch } from "../../../../../fetch/fetch";

const TotalPayment: React.FC<any> = (props) => {

    const [menu, setMenu] = useState("totalpaymentlist");

    // 데이터 맞추기 미처리 건수 뱃지
    const [reconcileCount, setReconcileCount] = useState<number>(0);

    const fetchReconcileCount = async () => {
        try {
            const result: any = await getFetch("/dashboard/payments/managepayment/reconcilelist?countOnly=1");
            if (result && result.message === "success") {
                setReconcileCount(result.count || 0);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        fetchReconcileCount();
    }, [menu]);


    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setMenu(newValue);
    };


    return (
        <div>
            <div style={{
                height : "30px"
            }}>
            </div>
            <div style={{ width: "100%", margin: "0 auto"}}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={menu}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" centered>
                                 <Tab label={<span style={{ fontFamily: "Apple_SB" }}>전체 결제 기록</span>} value="totalpaymentlist" />
                                 <Tab label={<span style={{ fontFamily: "Apple_SB" }}>월별 매출 통계</span>} value="totalsalelist" />
                                 <Tab label={<span style={{ fontFamily: "Apple_SB" }}>지점별 학생 출입 현황</span>} value="localaccess" />
                                 <Tab label={<span style={{ fontFamily: "Apple_SB" }}>데이터 맞추기{reconcileCount ? ` (${reconcileCount})` : ""}</span>} value="paymentreconcile" />
                            </TabList>
                        </Box>
                    </TabContext>
                </Box>
            </div>

            <div>
                {
                    menu === "totalpaymentlist" ?
                    <TotalPayementList user={props.user} /> : ""
                }
                {
                    menu === "totalsalelist" ?
                    <TotalSaleList user={props.user} /> : ""
                }
                {
                    menu === "localaccess" ?
                    <LocalAccess user={props.user} /> : ""
                }
                {
                    menu === "paymentreconcile" ?
                    <PaymentReconcile user={props.user} /> : ""
                }
            </div>
        </div>
    )

}

export default TotalPayment;
